import React, { CSSProperties } from "react";
import "./BfCard.scss";

type Props = {
  style?: CSSProperties;
  className?: string;
  noPadding?: boolean;
  children?: React.ReactNode;
};

const BfCard: React.FC<Props> = (props) => {
  return (
    <div
      className={`bf-card-component ${props.className || ""} ${
        props.noPadding ? "no-padding" : ""
      }`}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

export default BfCard;
